import styled from 'styled-components';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 30vh;
  min-width: 25vw;
`;
